import {useIntl} from "react-intl";
import * as React from "react";
import Speaker from "../../../../Elements/Icon/Icons/Safemate/outline/Speaker";
import { StyledButtonMob } from './index';
import { DeviceHardwareEnum, isGx8 } from '../../../DeviceHardwareEnum';
import { LabelEnum } from '../../LabelEnum';
import {Capabilities} from "@Safemate/Settings/Store/types";
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";

interface FindMeProps{
  isTracker: boolean;
  deviceId: number
  capabilities: Capabilities;
  findMe: Routine<ActionFunctionAny<Action<any>>>;
}

const FindMe = ({ isTracker, deviceId, capabilities, findMe }: FindMeProps) => {

  if(!isTracker) return null;
  if(!capabilities.findMe) return null;

  const { formatMessage } = useIntl();

  return(
    <StyledButtonMob
      title={formatMessage({id: LabelEnum.FIND_ME, defaultMessage: "Gjenfinnings lyd"})}
      onClick={(event: any) => {
        event.stopPropagation();
        findMe(deviceId);
      }}
      onKeyDown={(event: any) => {
        if (event.key === 'Enter')
          findMe(deviceId);
      }}
    >
      <Speaker
        size="medium"
        inline
      />
    </StyledButtonMob>
  )
};

export default FindMe;
